import cateringOrderBackend from '@/api/base/cateringOrderBackend'

export default {
  index(date, eventsLimit = null, buffetLimit = null, miniBuffetLimit = null) {
    const data = {
      events_limit: eventsLimit,
      buffet_limit: buffetLimit,
      mini_buffet_limit: miniBuffetLimit
    }
    const { api, paths } = cateringOrderBackend()
    return api.get(paths.timeSlots(date), { params: data })
  },
  closedHours() {
    const { api, paths } = cateringOrderBackend()
    return api.get(paths.closedHours())
  }
}
